import Slider from './_slider';

const sliderElements = [...document.querySelectorAll('.js-slider')];

sliderElements.map(sliderElement => {
    new Slider(sliderElement, {
        arrows: false,
        viewports: {
            lg: {
                arrows: true,
            }
        }
    });
});
